import axios from "axios";

const BASE_URL = "https://app-staging.synia.is/log-viewer/api/Demo";

export const fetchTableData = (filter) => {
  return axios.get(`${BASE_URL}/GetGrafanaPanel`, {
    params: {
      dashboardId: filter.dashboardId,
      panelId: filter.panelId,
      startDate: filter.startDate,
      endDate: filter.endDate,
      interval: filter.interval,
    },
  });
};

export const fetchIntegrationsData = (filter) => {
  return axios.get(`${BASE_URL}/GetGrafanaPanel`, {
    params: {
      dashboardId: filter.dashboardId,
      panelId: "AvgDurationChart",
      startDate: filter.startDate,
      endDate: filter.endDate,
      interval: filter.interval,
    },
  });
};

export const fetchReplicationData = (filter,panelId) => {
  return axios.get(`${BASE_URL}/GetGrafanaPanel`, {
    params: {
      dashboardId: filter.dashboardId,
      panelId,
      startDate: filter.startDate,
      endDate: filter.endDate,
      interval: filter.interval,
    },
  });
};
